import JobSeriesDetails from "./JobSeriesDetails/JobSeriesDetails"
import JobSeriesList from "./JobSeriesList/JobSeriesList"

const List = JobSeriesList
const Details = JobSeriesDetails

export default { List, Details }
